import { DateTime, Interval } from 'luxon'

/**
 * Calculate easter date for current year
 * Adapted from:
 * https://stackoverflow.com/questions/1284314/easter-date-in-javascript
 */
const getEasterDate = (): Date => {
    // Instantiate date object, set current year and time to midnight
    const date = new Date()
    const year = date.getFullYear()
    date.setHours(0, 0, 0, 0)

    // Find the golden number
    const golden = year % 19

    // Choose which version of the algorithm to use based on the given year
    const version = (year >= 2200 && year <= 2299)
        ? ((11 * golden) + 4) % 30
        : ((11 * golden) + 5) % 30

    // Determine whether or not to compensate for the previous step
    const compensation = ((version === 0) || (version === 1 && golden > 10)) ? (version + 1) : version

    // Use compensation first to find the month: April or March
    const month = (compensation >= 1 && compensation <= 19) ? 3 : 2

    // Then use compensation to find the full moon after the northward equinox
    const day = (50 - compensation) % 31

    // Mark the date of that full moon—the "Paschal" full moon
    date.setMonth(month, day)

    // Count forward the number of days until the following Sunday (Easter)
    date.setMonth(month, day + (7 - date.getDay()))

    // Gregorian Western Easter Sunday
    return date
}

const isChristmasToday = (): boolean => {
    const today = DateTime.local()
    const christmasStart = DateTime.fromFormat(`6-12-${today.year}`, 'd-MM-yyyy')
    const christmasEnd = DateTime.fromFormat(`2-01-${today.year + 1}`, 'd-MM-yyyy')

    return Interval.fromDateTimes(christmasStart, christmasEnd).contains(today)
}

const isEasterToday = (): boolean => {
    const today = DateTime.local()

    const easter = getEasterDate()
    const easterStart = DateTime.fromJSDate(easter).minus({ days: 5 })
    const easterEnd = DateTime.fromJSDate(easter).plus({ days: 2 })

    return Interval.fromDateTimes(easterStart, easterEnd).contains(today)
}

export {
    isChristmasToday,
    isEasterToday
}
